import React, { ReactNode } from 'react';
import { Popover, PopoverProps } from '@mantine/core';
import UpgradeCard from './UpgradeCard';

interface UpgradePopoverProps extends Omit<PopoverProps, 'children'> {
  children: ReactNode;
  upgradeTitle: string;
  upgradeDescription: string;
  onUpgrade: () => void;
  maxWidth?: number | string;
}

/**
 * A standardized popover component for upgrade prompts
 * 
 * This component provides a consistent upgrade popover experience across the app
 * using Mantine's Popover component and our UpgradeCard for content
 */
const UpgradePopover: React.FC<UpgradePopoverProps> = ({
  children,
  upgradeTitle,
  upgradeDescription,
  onUpgrade,
  maxWidth = 360,
  position = 'right',
  withArrow = true,
  withinPortal = true,
  shadow = 'md',
  offset = 8,
  closeOnClickOutside = true,
  trapFocus = false,
  ...props
}) => {
  return (
    <Popover
      position={position}
      withArrow={withArrow}
      withinPortal={withinPortal}
      shadow={shadow}
      offset={offset}
      closeOnClickOutside={closeOnClickOutside}
      trapFocus={trapFocus}
      clickOutsideEvents={['mousedown']}
      {...props}
    >
      <Popover.Target>{children}</Popover.Target>
      <Popover.Dropdown style={{ overflow: 'visible', minWidth: 320, maxWidth: 380, border: 'none', background: 'transparent', boxShadow: 'none' }}>
        <UpgradeCard
          upgradeTitle={upgradeTitle}
          upgradeDescription={upgradeDescription}
          onUpgrade={onUpgrade}
          maxWidth={maxWidth}
        />
      </Popover.Dropdown>
    </Popover>
  );
};

export default UpgradePopover; 